//Redux Toolkit
import { createSelector } from "@reduxjs/toolkit";

//Settings
import { _resultsPerPage } from "../../../constants/paginaton-settings";
import { SortOptions } from "../../../models/sorting/sort-options";

//Selectors
import { selectAllResults } from "../select-all-results";
import { selectCurrentSort } from "./select-current-sort";

//Util
import { sortResultList } from "../../../functions/sorting/sort-results";
import { isStringEmpty } from "drh-js-library/dist/drh-string-utils/is-string-empty";

export const selectSortedResults = createSelector(
	[selectAllResults, selectCurrentSort],
	(allResults, currentSort) => {
		//If no sort is chosen return the results in the original order.
		if (isStringEmpty(currentSort)) {
			return allResults;
		}

		return sortResultList(allResults, currentSort, SortOptions);
	},
);
